export default "__VITE_ASSET__OxgPY7jd89vmgHQlmb5h_Q__ 480w, __VITE_ASSET__Jhiobz1iAIl42UC3k5$exQ__ 745w";